<template>
  <div class="user-icon-comp">
    <el-dialog :visible.sync="isDoingUserIconCut" :closeOnClickModal="false" :showClose="false"
               :destroyOnClose="true" :appendToBody="true" :customClass="''">
      <div>
        <el-upload
          class="upload-demo"
          ref="upload"
          action="#"
          :show-file-list="false"
          :accept="'.png,.jpeg,.bmp'"
          :on-change="imgAdd"
          :file-list="userIconPreview"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">选择图片</el-button>
          <span style="color: #fd5f39;font-weight: bolder">只能上传png/jpeg/bmp文件</span>
          <!--                <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>-->
<!--          <div slot="tip" class="el-upload__tip">只能上传png/jpeg/bmp文件</div>-->
        </el-upload>
      </div>
      <br />
      <div>
        <div class="cropper-content">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="true"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :fixedBox="option.fixedBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :centerBox="option.centerBox"
            :high="option.high"
            :infoTrue="option.infoTrue"
            :maxImgSize="option.maxImgSize"
            @realTime="realTime"
            @imgLoad="imgLoad"
            @cropMoving="cropMoving"
            :enlarge="option.enlarge"
            :mode="option.mode"
            :limitMinSize="option.limitMinSize"
          ></vueCropper>
        </div>
        <div class="preview-result">
          <div class="icon-content">
            <img :src="previewResult" class="icon-img" />
          </div>
          <h3 class="icon-content-tip">头像预览</h3>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeThis()">取 消</el-button>
        <el-button type="primary" size="small" @click="submitUserIcon()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'UserIcon',
  props: ['isDoingUserIconCut'],
  data () {
    return {
      userIconPreview: [],
      option: {
        img: '',
        size: 1,
        full: false,
        outputType: 'png',
        canMove: true,
        fixedBox: true,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 200,
        autoCropHeight: 200,
        centerBox: false,
        high: false,
        cropData: {},
        enlarge: 1,
        mode: 'contain',
        maxImgSize: 2000,
        limitMinSize: [100, 100]
      },
      previews: {},
      previewStyle1: {},
      previewStyle2: {},
      previewStyle3: {},
      previewStyle4: {},
      previewResult: ''
    }
  },
  methods: {
    closeThis () {
      this.option.img = ''
      this.previewResult = ''
      this.$emit('closeUserIconDialog')
    },
    submitUserIcon () {
      this.$http.post(this.$api.saveUserIcon.url, {
        image: this.previewResult,
        userCode: this.$store.get('user').userCode
      }).then(_ => {
        if (_ && _.code === 200) {
          this.$message.success('头像保存成功')
          this.option.img = ''
          this.previewResult = ''
          this.$emit('closeUserIconDialog')
        } else if (_ && _.msg) {
          this.$message.warning(_.msg)
        }
      })
      console.log(this.option.img)
    },
    imgAdd (fileItem, fileList) {
      let file = fileItem.raw
      let reader = new FileReader()
      reader.onload = e => {
        let data
        if (typeof e.target.result === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }
        this.option.img = data
      }
      // 转化为base64
      reader.readAsDataURL(file)
      // 转化为blob
      // reader.readAsArrayBuffer(file)
    },
    // 实时预览函数
    realTime (imgData) {
      this.$refs.cropper.getCropData(data => {
        this.previewResult = data
      })
      /* let previews = data
      let h = 0.5
      let w = 0.2

      this.previewStyle1 = {
        width: previews.w + 'px',
        height: previews.h + 'px',
        overflow: 'hidden',
        margin: '0',
        zoom: h
      }

      this.previewStyle2 = {
        width: previews.w + 'px',
        height: previews.h + 'px',
        overflow: 'hidden',
        margin: '0',
        zoom: w
      }

      this.previewStyle3 = {
        width: previews.w + 'px',
        height: previews.h + 'px',
        overflow: 'hidden',
        margin: '0',
        zoom: (100 / previews.w)
      }

      this.previewStyle4 = {
        width: previews.w + 'px',
        height: previews.h + 'px',
        overflow: 'hidden',
        margin: '0',
        zoom: (100 / previews.h)
      }

      this.previews = data */
    },
    imgLoad (msg) {
      console.log(msg)
    },
    cropMoving (data) {
      this.option.cropData = data
    }
  }
}
</script>

<style scoped>
  .cropper-content, .preview-result {
    display: inline-block;
    width: 400px;
    height: 400px;
  }
  .preview-result {
    float: right;
    background: #cccccc;
  }
  .icon-content {
    width: 200px;
    height: 200px;
    background: #ffffff;
    margin: 80px auto auto;
  }
  .icon-content-tip {
    margin: 40px auto auto;
    width: 200px;
    text-align: center;
  }
  .icon-img {
    width: 200px;
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserIconCut/UserIcon.vue